import { LoanApplicationStepper } from "../LoanApplicationSteps/Stepper";
import LoanApplicationFlowFooter from "./Footer";
import LoanApplicationForm from "./Form";
import LoanApplicationFlowHeader from "./Header";
import { useDpConfig } from "../../contexts/dpConfig";
import SaasMarketplaceTopBanner from "../../components/SaasMarketplace/SaasMarketplaceTopBanner";

const LoanApplicationFlow = () => {
  const {
    state: { settings },
  } = useDpConfig();
  return (
    <LoanApplicationStepper>
      <div className="cx-flex cx-flex-col cx-items-center cx-w-full cx-h-full cx-min-h-screen">
        <SaasMarketplaceTopBanner />
        <LoanApplicationFlowHeader />
        <LoanApplicationForm />
        {!settings.hideFooter && <LoanApplicationFlowFooter />}
      </div>
    </LoanApplicationStepper>
  );
};

export { LoanApplicationFlow };
